const i18n = require('i18n');
const PSEvents = require('PSEvents');
const SlotUI = require('SlotUI');
const PSState = require('PSState');
const PSConfig = require('PSConfig');
const { FeatureStates, GameStates } = require('ClientStates');
const GenericUI = require('GenericUI').ui;
let Engine;
let FreeRounds;
let PlayHistory;
let SlowConnectionChecker;
let Purchases;
let SpecialBets;
let genericData = {};
let savedGenericData = null;
let replayGenericData = null;
let isInited = false;
let isSpinReqLocked = false;
let loadSceneTimer = null;

const SLOW_CONNECTION_CHECK_INTERVAL = 10000;

export const initEngine = () => {
    Engine = window.PSGames.CommonAPI.Engine;
    FreeRounds = window.PSGames.CommonAPI.FreeRounds;
    PlayHistory = window.PSGames.CommonAPI.PlayHistory;
    SlowConnectionChecker = window.PSGames.CommonAPI.SlowConnectionChecker;
    Purchases = window.PSGames.CommonAPI.Purchases;
    SpecialBets = window.PSGames.CommonAPI.SpecialBets;
    Engine.start(PSGames.launchParams).then((data) => onGameOpened(data));

    GenericUI.registerComplianceBarDisplayedListener();
};

const registerHandlers = () => {
    PSEvents.subscribe(PSEvents.SPIN_REQUEST, () => {
        if (PSState.selectedBooster && PSState.gameState === GameStates.MAIN) {
            boosterSpinRequest();
        } else {
            spinRequest();
        }
    });

    PSEvents.subscribe(PSEvents.REDEEM_REQUEST, (data) => {
        redeemRequest(data);
    });

    PSEvents.subscribe(PSEvents.BUY_REQUEST, (data) => {
        buyRequest(data);
    });

    PSEvents.subscribe(PSEvents.GAME_CLOSED, (data) => {
        closeGameRequest();
    });

    PSEvents.subscribe(PSEvents.LOGOUT, (data) => {
        logoutReqeust();
    });

    PSEvents.subscribe(PSEvents.ROUND_HISTORY_REQUEST, (page) => {
        gameHistoryRequest(page);
    });
};

/**********************************************
 ******************REQUESTS********************
 **********************************************/

const spinRequest = () => {
    if (isSpinReqLocked) {
        return;
    }
    genericData = {};

    const action = {
        type: 'SPIN',
        data: {
            betAmount: PSState.betAmount,
        }
    };
    if (PSState.freeRoundsData && PSState.freeRoundsData.status !== 'FINISHED') {
        action.data.freeRoundId = PSState.freeRoundsData.id;
    }
    Engine.sendGameAction(action).then((data) => {
        onSpinResult(data);
    }).catch((e) => {
        if (CC_PREVIEW) {
            console.error(e);
        } else {
            console.warn(e);
        }
    });
};

const buyRequest = ({ featureId, selectedBet }) => {
    isSpinReqLocked = true;
    PSState.set({ selectedBooster: null });
    PSEvents.publish(PSEvents.SPIN_REQUEST, { betAmount: selectedBet });
    Purchases.buy(featureId, selectedBet).then(data => {
        isSpinReqLocked = false;
        onSpinResult(data);
    }).catch((e) => {
        if (CC_PREVIEW) {
            console.error(e);
        } else {
            console.warn(e);
        }
    });
};

const boosterSpinRequest = () => {
    SpecialBets.specialBetSpin(PSState.selectedBooster.betType, PSState.betAmount).then(data => {
        onSpinResult(data);
    }).catch((e) => {
        if (CC_PREVIEW) {
            console.error(e);
        } else {
            console.warn(e);
        }
    });
};

export const activateFreeRound = (id) => { FreeRounds.activateFreeRound(id) };
export const rejectFreeRound = (id) => { FreeRounds.rejectFreeRound(id) };
export const cheatRequest = (data) => Engine.cheatRequest(data);
export const getSessionData = () => { return Engine.getSessionState(); };
export const getInitData = () => {
    if (SlotUI.isReplayMode()) {
        // return new data which is composed of saved data and the replayGenericData retrieved from engine
        return Object.assign({}, savedGenericData || genericData, replayGenericData);
    }

    return genericData;
};
export const isInitialized = () => { return isInited; };
export const getPurchases = () => { return Purchases.getPurchases(); };

export const getSavedInitialData = () => { return savedGenericData };
export const saveInitialData = (data) => { savedGenericData = data };
export const updateInitialData = (data) => { genericData = data; };

export const redeemRequest = (data) => {
    return window.PSGames.CommonAPI.Engine.sendGameAction({
        type: 'REDEEM',
        data
    }).then((result) => { onRedeemResult(result) });
};

export const checkSlowConnection = (slowConnection) => {
    if (SlowConnectionChecker) {
        SlowConnectionChecker.start(slowConnection, SLOW_CONNECTION_CHECK_INTERVAL);
    } else {
        console.warn('SlowConnectionChecker is not implemented for current engine.');
    }
};


export const isYggdrasilProvider = () => window.PSGames.launchParams.provider === 'yggdrasil';

const useOperatorSoundSetting = () => isYggdrasilProvider() && SlotUI.isRewatchMode();

/**********************************************
 ******************RESPONSES*******************
 **********************************************/

const onSpinResult = (data) => {
    PSState.balance = Engine.getSessionState().balance;
    PSState.prevGameState = PSState.gameState;
    PSState.gameState = data.gameState;
    PSState.configState = data.configState;
    PSState.spinWinning = data.winnings.totalWinning;
    PSState.freeRoundsData = data.freeRoundsData;
    PSState.maxWinReached = data.maxWinReached;
    PSState.actionWinnings = data.actionWinnings;

    if (data.progressPerBet) {
        PSState.progressPerBet = data.progressPerBet;
    }

    if (data.freeRoundsData) {
        if (data.freeRoundsData.type === 'UNSPECIFIED') {
            PSEvents.publish(PSEvents.FREE_ROUNDS_UNSPECIFIED);
        }
        switch (data.freeRoundsData.status) {
            case 'ACTIVE':
                PSEvents.publish(PSEvents.FREE_ROUNDS_PROGRESS);
                break;
            case 'FINISHED':
                PSEvents.publish(PSEvents.FREE_ROUNDS_END);
                break;
        }
    }

    if (data.redeemables) {
        PSState.redeemables = data.redeemables;

        if (data.redeemables.length > 0) {
            PSEvents.publish(PSEvents.GENERIC_REDEEN_START, data.redeemables);
        }
    } else {
        PSState.redeemables.length = 0;
    }


    PSState.betWinning = data.roundWinnings;

    switch (data.featureState) {
        case FeatureStates.ENTER:
            PSEvents.publish(PSEvents.GENERIC_FREE_SPIN_START, data.freespinsData);
            break;
        case FeatureStates.ACTIVE:
            PSEvents.publish(PSEvents.GENERIC_FREE_SPIN_PROGRESS, data.freespinsData);
            break;
        case FeatureStates.EXIT:
            PSEvents.publish(PSEvents.GENERIC_FREE_SPIN_PROGRESS, data.freespinsData);
            PSEvents.publish(PSEvents.GENERIC_FREE_SPIN_END, data.freespinsData);
            PSState.betWinning = data.freespinsData.context.freeSpinsAccumulatedWinnings;
            break;
    }


    if (data.gameState === GameStates.MAIN && !SlotUI.isReplayMode()) {
        saveInitialData(data);
    }

    PSEvents.publish(PSEvents.SPIN_RESPONSE, data);
};

const onRedeemResult = (data) => {
    PSState.balance = Engine.getSessionState().balance;
    PSState.gameState = data.gameState;

    switch (data.featureState) {
        case FeatureStates.ENTER:
            PSEvents.publish(PSEvents.GENERIC_FREE_SPIN_START, data.freespinsData);
            break;
    }

    PSEvents.publish(PSEvents.REDEEM_RESPONSE, data);
};

const onGameOpened = (data) => {
    const { languageCode, currencyCode, jurisdictionCode, gameVersion, playMode, maxWin, soundEnabled } = Engine.getSessionState();
    let { availableBetAmounts, betAmount, initialData, gameConfiguration } = data;
    const { gameState, configState, freeRoundsData, balance, progressPerBet } = initialData;
    const {
        minSpinDuration,
        slowConnection, autoplaySpinsLimit, gameBaseURL,
        gameName, gameDisplayName, sessionTime,
        funBanner, closeButton, showRtpAndMaxWin,
        rtp, maxExposure, autoplayLevels, disableSkip,
        provider, errorDialogsDisabled
    } = PSGames.launchParams;

    genericData = initialData;
    if (!SlotUI.isReplayMode()) {
        saveInitialData(initialData);
    }
    isInited = true;

    PSConfig.setConfig({
        language: languageCode,
        currency: currencyCode,
        gamePlayStatus: 2,
        jurisdiction: jurisdictionCode,
        gameName,
        gameDisplayName,
        gameVersion,
        playMode,
        cheatMode: PSConfig.CheatModes.Active,
        minSpinDuration,
        slowConnection,
        autoplayPreventingStates: [],
        sessionTime,
        maxWin,
        autoplaySpinsLimit,
        gameBaseURL,
        funBanner,
        closeButton,
        showRtpAndMaxWin,
        rtp,
        maxExposure,
        autoplayLevels,
        disableSkip,
        provider,
        errorDialogsDisabled,
    });

    let betWinning;

    switch (gameState) {
        case GameStates.MAIN:
            betWinning = 0;
            break;
        case GameStates.RETRIGGERING:
            betWinning = initialData.respinsData.context.respinsAccumulatedWinnings;
            break;
        case GameStates.FREESPINS:
        case GameStates.FREESPINS_SUPER:
            betWinning = initialData.freespinsData.context.freeSpinsAccumulatedWinnings;
            break;
    }

    PSState.set({
        availableBetAmounts,
        betAmount,
        gameState,
        configState,
        freeRoundsData,
        gameConfiguration,
        balance,
        betWinning,
        progressPerBet,
        soundEnabled: useOperatorSoundSetting() ? soundEnabled : PSState.soundEnabled
    }, false);

    i18n.init(languageCode, currencyCode);

    Engine.onMessage('RealityCheck', (data) => onRealityCheck(data));
    Engine.onMessage('BalanceUpdate', (data) => onBalanceUpdate(data));
    Engine.onMessage('GameRoundEnded', (data) => onGameRoundEnded(data));
    Engine.onMessage('CustomEvent', (data) => onCustomMessage(data));
    Engine.onMessage('SkipRestoreActionResponse', (data) => onSkipRestoreActionResponse(data));
    Engine.onMessage('GameStartReplayActionResponse', (data) => onGameStartReplayActionResponse(data));

    Engine.onMessage('startReplay', (data) => onStartReplay(data));
    Engine.onMessage('stopReplay', (data) => onStopReplay(data));
    Engine.onMessage('resumeGame', (data) => onResumeGame(data));

    GenericUI.initConfig(PSConfig.get());
    GenericUI.initState(PSState.get());

    PSEvents.publish(PSEvents.GENERIC_CONFIG, PSConfig.get());
    PSEvents.publish(PSEvents.COMMON_INITIALIZED, PSState.get());
    PSEvents.publish(PSEvents.GENERIC_SHOW, initialData);
};

const onGameHistoryResponse = (data) => {
    PSEvents.publish(PSEvents.ROUND_HISTORY_RECEIVED, data);
};

const onRealityCheck = (data) => {
    PSEvents.publish(PSEvents.REALITY_CHECK, data);
};

const onBalanceUpdate = ({ balance }) => {
    PSState.balance = balance;
    PSEvents.publish(PSEvents.ENGINE_BALANCE_UPDATE);

    return { balance };
}

const onGameRoundEnded = (data) => {
    PSEvents.publish(PSEvents.GAME_ROUND_ENDED, data);
}

const onCustomMessage = (data) => {
    PSEvents.publish(PSEvents.ENGINE_CUSTOM_MESSAGE, data);
}

const onSkipRestoreActionResponse = (data) => {
    Object.assign(genericData, data);
}
const onGameStartReplayActionResponse = (data) => {
    replayGenericData = data;
}
const onStartReplay = (data) => {
    const replayBackButton = document.getElementById('pc_replay-back-button');

    // hack! dont process start replay if replay back button is not present. It means we are in history list (somewhere else!)
    // start replay is emitted even when stopReplay is processed
    if (!replayBackButton || !SlotUI.isReplayMode() || !data) {
        return;
    }

    const { betAmount, balance } = data;

    // if the state is not null, means it is replay from replay
    if (PSState.stateBeforeReplay === null) {
        // save booster and bet state before going to replay
        PSState.set({
            stateBeforeReplay: {
                selectedBooster: PSState.selectedBooster,
                betAmount: PSState.betAmount,
            }
        }, true);
    }

    PSState.set({
        gameState: GameStates.MAIN,
        betAmount,
        balance,
        selectedBooster: null
    }, true);
    GenericUI.initReplay();

    PSEvents.publish(PSEvents.START_REPLAY, data);

    PSEvents.publish(PSEvents.START_SCENE_LOAD);
    cc.director.loadScene('Game', () => {
        PSEvents.publish(PSEvents.SCENE_LOAD_COMPLETE);
    });
}

const onStopReplay = (data) => {
    replayGenericData = null;
    // clear loading scene queue
    PSEvents.publish(PSEvents.STOP_REPLAY, data);
}

const onResumeGame = (data) => {

    if (data && data.isExitReplay) {
        const { gameState, balance } = data;

        // use state before replay to set the bet and booster option
        PSState.set(Object.assign({
            balance,
            gameState,
            stateBeforeReplay: null
        }, PSState.stateBeforeReplay), true);

        PSState.balance = balance;
        PSEvents.publish(PSEvents.ENGINE_BALANCE_UPDATE);

        PSState.set({ isExitReplay: true }, false);

        if (loadSceneTimer) {
            clearTimeout(loadSceneTimer);
        }

        loadSceneTimer = setTimeout(() => {
            let initData = getSavedInitialData();

            if (!initData) {
                // saveInitialData();
                cc.error('init data not saved');
            }

            updateInitialData(initData);

            PSEvents.publish(PSEvents.START_SCENE_LOAD);
            cc.director.loadScene('Game', () => {
                PSEvents.publish(PSEvents.SCENE_LOAD_COMPLETE);
            });
        }, 0)
    }

    PSEvents.publish(PSEvents.GAME_RESUMED, data);
}

/**
 * Request logout
 */
const logoutReqeust = () => { Engine.logout() };

/**
 * Close game session
 */
const closeGameRequest = () => {
    if (window.PSGames.events) {
        window.PSGames.events.handler('close', {});
    }
    Engine.close();
};

/**
 * Request request game history data
 */
const gameHistoryRequest = (page) => {
    PlayHistory.getHistory(page).then((data) => {
        onGameHistoryResponse(data);
    })
};

if (!CC_EDITOR) {
    registerHandlers();
}
